import React, { useEffect, useState } from 'react'
import './Reference.css'; 
import DocIcon from "../../images/google-docs.png";
import { Container, Col, Row } from 'react-bootstrap';  
 
import { ReferenceDocumentsList } from "../../apis/CustomerAPI";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ShowCustomerDocument } from '../../utils/Utility';

export default function Reference() {  
    const {user} = useSelector((state) => state.auth);
    const [customerdocs, setCustomerDocs] = useState([]); 

    useEffect(() => {
        async function GetCustomerDocs(){
          var result = await ReferenceDocumentsList(user.customerid);
          var data = result.data; 
          setCustomerDocs(data);  
        } 
        GetCustomerDocs(); 
    },[])
    //
    async function getdocument(docid) {
        // var result = await GetDocumentById(docid);
        // var data = result.data;
        // console.log(data);
        // var wndw = window.open("", "_blank");
        // setTimeout(() => {
        // wndw.document.write(
        //     "<iframe width='100%' height='640px' src='"+data.documentPath+"#toolbar=0"+"'></iframe>"
        // );
        // wndw.document.title = data.documentName;
        // }, 0);
        // setTimeout(function(){ wndw.stop() }, 1000);

        ShowCustomerDocument(docid);
    } 
    

       
    return (
    <>
        <Container className='mb-5'>
            <Row className='page-head-row'>
                <Col lg={6} md={6} sm={12}>
                    <div className='page-title'> 
                        <h2>Reference Documents</h2> 
                    </div> 
                </Col> 
                <Col lg={6} md={6} sm={12}>
                </Col> 
            </Row>
            <Row>
                <Col lg={12} md={12}>
                    <div className='reference-documents-row'> 
                    {customerdocs.map((customerlist) => (
                        <div className='reference-documents' key={customerlist.id}>
                            <div className='reference-documents-inner'>
                                <div className='reference-documents-icon'> 
                                    <img src={DocIcon} alt="QCR-Doc-Icon" width={30} />
                                </div>
                                <div className='reference-documents-name'>
                                    {/* <div className='documents-name'>
                                        {customerlist.documentName}
                                    </div> */}
                                    <div className='documents-link'>
                                        <Link onClick={() => getdocument(customerlist.id)}>{customerlist.documentName}{" "}</Link> 
                                    </div>  
                                </div>
                            </div>
                        </div> 
                    ))}
                        {/* <div className='reference-documents'>
                            <div className='reference-documents-inner'>
                                <div className='reference-documents-icon'>
                                    <i className="fa-solid fa-file-pdf"></i>
                                </div>
                                <div className='reference-documents-name'>
                                    Reference Material 1
                                </div>
                            </div>
                        </div>
                        <div className='reference-documents'>
                            <div className='reference-documents-inner'>
                                <div className='reference-documents-icon'>
                                    <i className="fa-solid fa-file-pdf"></i>
                                </div>
                                <div className='reference-documents-name'>
                                    Reference Material 2
                                </div>
                            </div>
                        </div>
                        <div className='reference-documents'>
                            <div className='reference-documents-inner'>
                                <div className='reference-documents-icon'>
                                    <i className="fa-solid fa-file-pdf"></i>
                                </div>
                                <div className='reference-documents-name'>
                                    Reference Material 3
                                </div>
                            </div>
                        </div>
                        <div className='reference-documents'>
                            <div className='reference-documents-inner'>
                                <div className='reference-documents-icon'>
                                    <i className="fa-solid fa-file-pdf"></i>
                                </div>
                                <div className='reference-documents-name'>
                                    Reference Material 4
                                </div>
                            </div>
                        </div>
                        <div className='reference-documents'>
                            <div className='reference-documents-inner'>
                                <div className='reference-documents-icon'>
                                    <i className="fa-solid fa-file-pdf"></i>
                                </div>
                                <div className='reference-documents-name'>
                                    Reference Material 5
                                </div>
                            </div>
                        </div>
                        <div className='reference-documents'>
                            <div className='reference-documents-inner'>
                                <div className='reference-documents-icon'>
                                    <i className="fa-solid fa-file-pdf"></i>
                                </div>
                                <div className='reference-documents-name'>
                                    Reference Material 6
                                </div>
                            </div>
                        </div> */}
                    </div>   
                </Col> 
            </Row> 
        </Container>
    </>
    )
}
